var _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalloon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 226,
    viewBox: "0 0 186 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.5111,
    cy: 112.713,
    rx: 92.5002,
    ry: 112.721,
    transform: "rotate(-1.21091 92.5111 112.713)",
    fill: "url(#paint0_radial_543_47)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_543_47",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.2456 84.1892) rotate(65.5349) scale(155.178 127.341)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E95757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B1A1A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloon);
export default __webpack_public_path__ + "static/media/balloon.a536f8658431dc17d9cb75eecf8b5893.svg";
export { ForwardRef as ReactComponent };